import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { skillQueryKeys } from "./skillQueryKeys";

/**
 * Distinct tags across skills the caller can see in the active org.
 *
 * Disabled until ``orgId`` resolves so the picker doesn't fire a request
 * keyed on ``undefined``. Cached briefly so successive autocomplete dropdowns
 * inside the same editor session don't refetch.
 */
export function useKnownSkillTags(orgId: string | undefined) {
  const { skillService } = useDomainServices();

  return useQuery<string[]>({
    queryKey: skillQueryKeys.orgTags(orgId),
    queryFn: ({ signal }) =>
      skillService.listKnownTags({ abortSignal: signal, orgId }),
    enabled: orgId !== undefined,
    staleTime: 30_000,
  });
}
